module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70204/img/podcast-zero.png"